import {
  ClientModel,
  Emma,
} from '@mercadoni/sinister/dist/lib/src/entities/clientModel'

const emmaMiddleware = (emma: Emma) => ({
  ...emma,
  isEnabled: emma?.isEnabled ?? false,
})

const monitorMiddleware = (monitor: ClientModel['monitor']) => {
  return {
    ...monitor,
    sentry: { enable: false },
    raygun: {
      enabled: false,
    },
    emma: emmaMiddleware(monitor?.emma || {}),
    beacon: {
      isEnabled: false,
    },
  }
}

export default monitorMiddleware
